export default __webpack_public_path__ + "static/media/shounak 1.f247a976.svg";